<script setup>
import { ref, computed } from 'vue'
import { formatRelativeTime } from '@/common/format'
import { useCabinetState } from '../composables/CabinetState.js'
import { useCatalogState } from '../composables/CatalogState.js'
import { useUserInventory } from '../composables/UserInventory.js'

const props = defineProps({
});

const emit = defineEmits([ "close" ]);

function close(e) {
  emit("close", e);
}

const {
  currentUserId,
  getUserDisplayName,
} = useUserInventory();

const {
  selectedTrayName,
  selectedTrayItem,
} = useCatalogState();

const {
  isReferencing,
  isOpening,
  isOpen,
  isPrevOpen,
} = useCabinetState();
</script>

<template>
  <!-- persistent not-escapable -->
  <Modal id="privateWindow" size="3xl" class="non-escapable-modal dark:bg-gray-900" @close="(e) => close(e)" @click.outside="(e) => close(e)">
    <template #header>
      <div class="flex items-center text-lg dark:text-white">
        Osebni predal
      </div>
    </template>
    <template #body>
      <div class="grid place-items-center w-full gap-8 mb-4 dark:text-white" style="min-height: 250px; max-height: 1000px;" v-if="selectedTrayItem">

        <div v-if="selectedTrayItem.status == 'active'">
          Predal je na voljo.
        </div>
        <div class="text-blue-500" v-else-if="selectedTrayItem.status == 'occupied' && selectedTrayItem.userId == currentUserId">
          Predal je v uporabi.
        </div>
        <div class="text-center" v-else-if="selectedTrayItem.status == 'occupied'">
          <!-- Note: that query returns only for the current user, so currentUserId is work-around -->
          <div class="mb-2" v-if="selectedTrayItem.userId || currentUserId">
            <i class="fa fa-user dark:text-gray-300 mr-2"></i> {{ getUserDisplayName(selectedTrayItem.userId || currentUserId) }}
          </div>
          <div class="mb-2" v-if="selectedTrayItem.occupiedTime">
            {{ formatRelativeTime(selectedTrayItem.occupiedTime) }}
          </div>
          <div class="text-red-500 dark:text-red-500">
            Predal je zaseden.
          </div>
        </div>
        <div class="text-red-500 dark:text-red-500" v-else-if="selectedTrayItem.status == 'locked'">
          Predal je zaklenjen.
        </div>

      </div>
    </template>
    <template #footer>
      <div class="flex justify-items-end w-full" style="min-height: 30px;" v-if="selectedTrayItem">
        <Button type="secondary" @click="close()" v-if="!isReferencing && !isOpening && !isOpen">Zapri okno</Button>
        <div class="m-auto">
          <span v-if="isReferencing" class="text-gray-500 bg-white outline-none rounded-lg text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300">
            <Spinner size="6" style="display: inline-block;" /> <span style="display: inline-block; position: relative; top: 3px; left: 10px;">Postavljam omaro v referenco...</span>
          </span>
          <span v-else-if="!isReferencing && !isOpen && isOpening" class="text-gray-500 bg-white outline-none rounded-lg text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300">
            <Spinner size="6" style="display: inline-block;" /> <span style="display: inline-block; position: relative; top: 3px; left: 10px;">Odpiram predal {{ selectedTrayName }}</span>
          </span>
          <span v-else-if="!isReferencing && isOpen && !isPrevOpen" class="text-gray-500 bg-white outline-none rounded-lg text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300">
            <i class="fa fa-lock-open text-green-500" style="position: relative; top: 2px;"></i> <span style="display: inline-block; position: relative; top: 3px; left: 10px;">{{ $t('catalog.tray_open_message') }}</span>
          </span>
          <span v-else-if="!isReferencing && isPrevOpen && !isOpening" class="text-gray-500 bg-white outline-none rounded-lg text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300">
            <i class="fa fa-triangle-exclamation text-amber-500" style="position: relative; top: 3px;"></i> <span style="display: inline-block; position: relative; top: 3px; left: 10px;">Za nadaljevanje najprej zapri prejšnji predal.</span>
          </span>
        </div>
        <div>
        <!-- <Button type="primary" :enabled="canOpenTray && canReturnArticle && canOpenTrayPermissions && canOpenTrayStatus" @click="openTray(selectedTrayItem)" v-if="!isReferencing && !isOpening && !isOpen">{{ $t('catalog.open_tray') }}</Button> -->
        <!-- <Button type="primary" :enabled="canApplyStock" @click="applyStock(selected)" v-if="isEditStockQuantity && !(isEditStockQuantity && isCabinetBorrowMode)">Potrdi</Button> -->
        </div>
      </div>
    </template>
  </Modal>
</template>